// Button click to tedirect Section..

$('[data-redirect-section-btn]').on('click',function(){
  var $this = $(this);
  var targetElement = $this.data('target-id'),
      offsetTop = document.getElementById(targetElement).offsetTop;
  $('html, body').animate({scrollTop:offsetTop},1500);
});